<template>
  <div class="nos-services">
    <div class="central-container">
      <div class="breadcrumb">
        <router-link class="breadcrumb-item" to="/">Accueil</router-link><span class="breadcrumb-separator">></span><span class="breadcrumb-current-item">Nos services</span>
      </div>
      <div class="main-title">
        <h1>Nos services</h1>
      </div>
    </div>
    <div class="bloc_a">
      <h2>{{PageData.bloc_a_name}}</h2>
      <div class="description" v-html="PageData.bloc_a_description"></div>
      <!-- <router-link :to="PageData.bloc_a_link">En savoir plus</router-link>-->
    </div>
    <div class="central-container">
      <div class="bloc_b">
        <div class="content">
          <h2>{{PageData.bloc_b_name}}</h2>
          <div class="description" v-html="PageData.bloc_b_description"></div>
          <!-- <router-link :to="PageData.bloc_b_link">En savoir plus</router-link>-->
        </div>
      </div>
      <div class="bloc_c">
        <div class="content">
          <h2>{{PageData.bloc_c_name}}</h2>
          <div class="description" v-html="PageData.bloc_c_description"></div>
          <!-- <router-link :to="PageData.bloc_c_link">En savoir plus</router-link>-->
        </div>
      </div>
      <div class="bloc_d">
        <div class="image">
          <img v-lazy="PageData.bloc_d_image" />
        </div>
        <div class="content">
          <h2>{{PageData.bloc_d_name}}</h2>
          <div class="description" v-html="PageData.bloc_d_description"></div>
        <!--  <router-link :to="PageData.bloc_d_link">En savoir plus</router-link>-->
        </div>
      </div>
      <div class="bloc_e">
        <div class="content">
          <h2>{{PageData.bloc_e_name}}</h2>
          <div class="description" v-html="PageData.bloc_e_description"></div>
          <!-- <router-link :to="PageData.bloc_e_link">En savoir plus</router-link>-->
        </div>
        <div class="image">
          <img v-lazy="PageData.bloc_e_image" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import { BACKEND_API } from "@/config/api";
  import { API_ROUTE } from "@/config/api";
  import Metatags from "@/script/metatags.js";

  export default {
    name: "Services",
    data: () => {
      return {
        errorMessage: "",
        PageData: ""
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      Metatags.update(
          'Les services Flaxeo pour un site web performant',
          'Flaxeo vous propose des services et un suivi client de qualité pour un site web performant.'
      );
      BACKEND_API.get(API_ROUTE.SERVICES)
        .then(response => {
          this.PageData = response.data[0];
        })
        .catch(e => {
          this.errorMessage = e;
        });
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/styles/_variables.scss";

  .nos-services {
    padding-top: 30px;
    max-width: 1365px;
    margin: 0 auto;
    font-size: 0.9em;

    .central-container {
      max-width: 1081px;
      margin: 0 auto;

      .description {
        text-align: left;

        &+a {
          background: $main-text-color;
          color: #fff;
          padding: 10px 30px;
          border-radius: 30px;
          text-decoration: none;
          display: inline-block;
          cursor: pointer;
        }
      }
      .bloc_b,
      .bloc_c {
        display: flex;

        .content {
          width: calc(50% - 2px);
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .description {
            color: $second-text-color;
            background-color: white;
          }
        }
      }
      .bloc_b {
        margin-top: 100px;

        &:after {
          content: " ";
          background: url("../assets/x.png") right no-repeat;
          background-size: 370px;
          background-position-x: 0;
          width: 313px;
          height: 345px;
          margin-top: -30px;
          position: absolute;
          right: 0;
          display: block;
        }
      }
      .bloc_c {
        margin-top: 40px;
        justify-content: flex-end;
      }
      .bloc_d ,
      .bloc_e {
        display: flex;
        margin-top: 100px;
        border: 2px solid $second-bg-color;
        background-color: white;

        .image,
        .content {
          width: 50%;
        }
        .content {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          padding: 20px;
          width: 50%;

          .description {
            color: $second-text-color;
            background-color: white;
          }
        }
        .image {
          width: calc(50% - 40px);
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            object-fit: cover;
            display: block;
            max-width: calc(100% - 80px);
            height: calc(100% - 80px);
            max-height: 300px;
          }
        }
      }
      .bloc_d {
        border-left-width: 50px;
      }
      .bloc_e {
        border-right-width: 50px;
        margin-bottom: 60px;
        margin-top: 160px;
      }
    }
    .main-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      h1 {
        margin-top: 40px;
        text-align: left;
        color: $second-bg-color;
        text-transform: uppercase;
        margin-bottom: 80px;
        background-color: white;
      }
    }
    h2 {
       text-transform: uppercase;
       font-weight: bold;
       font-size: 26px;
       line-height: 26px;
      background-color: white;
    }
    .bloc_a {
      position: relative;
      background: $second-bg-color;
      text-align: left;
      padding: 50px 142px;

      h2 {
        background-color: unset;
      }
      .description {
        color: #ffffff;

        a {
          color: #ffffff;
        }
      }
    }
  }

  @media screen and (max-width: 1365px) {
    .nos-services {
      .bloc_a {
        padding: 50px calc((100% - 1081px) / 2);
      }
      .central-container {
        .bloc_b:after {
          width: calc(313px - (1365px - 100%) / 2);
        }
      }
    }
  }
  @media screen and (max-width: 1081px) {
    .nos-services {
      .bloc_a {
        padding: 50px 20px;
      }
      .central-container {
        padding: 0 20px;
      }
    }
  }
  @media screen and (max-width: 640px) {
    .nos-services {
      .central-container {
        .bloc_b,
        .bloc_c {
          .content {
            width: 100%;
            text-align: center;
            align-items: center;
          }
        }
        .bloc_d,
        .bloc_e {
          border: unset;
          background-color: unset;
          position: relative;

          .content {
            width: 100%;
            padding: 20px 0 0;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;
          }
          .image {
            position: absolute;
            z-index: 3;
            opacity: 0.1;
            width: 100%;
            top: calc(50% + 30px);
            transform: translate(0, -50%);
            background-color: white;

            img {
              max-width: 100%;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 440px) {
    .nos-services {
      .central-container {
        .bloc_d,
        .bloc_e {
          .image {
            display: none;
          }
        }
      }
    }
  }
</style>
